<template>
    <div>
      <section>
        <xlsx-workbook>
          <xlsx-sheet
            :collection="sheet.data"
            v-for="sheet in sheets"
            :key="sheet.name"
            :sheet-name="sheet.name"
          />
          <xlsx-download>
            <b-button block variant="gradient-success"  class="mr-1"  >  Excel  </b-button>
          </xlsx-download>
        </xlsx-workbook>
      </section>
     
 
    </div>
  </template>
  
  <script>
  import { XlsxRead, XlsxTable, XlsxSheets, XlsxJson, XlsxWorkbook, XlsxSheet, XlsxDownload } from "vue-xlsx"
  import { BCard, BCardText, BLink,BRow, BCol, BTabs, BCardBody, BForm,BFormGroup, BFormInput, BButton, BFormSelect, BSpinner } from "bootstrap-vue";
  export default {
    components: {
      XlsxRead,
      XlsxTable,
      XlsxSheets,
      XlsxJson,
      XlsxWorkbook,
      XlsxSheet,
      XlsxDownload,
      BButton,
      BFormInput
    },
    data() {
      return {
        selectedSheet: null,
        sheetName: null,
        collection: [{ a: 1, b: 2 }],
        // sheets: [  { "name": "Pagina 1", "data": [ { "Valor": 1 , "Data": 2 }, {"Valor":2, "Data":19} ] } ],
        // sheets: [  { "name": "Pagina 1", "data": [ { "Valor": 1 , "Data": 2 }, {"Valor":2, "Data":19} ] } ]
      };
    },
    computed:{

        sheets(){
                let a = this.$store.state.estabelecimentos.list_order
                let b = [];
                for(let c in a){
                    let status = ""
                    if(a[c].status == 3){
                            status = "Pago"
                    }

                    if(a[c].status == 1){
                            status = "Aberto"
                    }


                    let d = {
                        Aluno: a[c].customer.name,
                        // valor: a[c].valor,
                        // custo_unitario: 2.00,
                        // custo_porcentagem: a[c].valor - a[c].valorLiquido,
                        // custo_total: a[c].valor - a[c].valorLiquido + 2,
                        valor_liquido: a[c].valorLiquido,
                        valor_guarani: a[c].guarani,
                        // Metodo: a[c].method,
                        Cambio: a[c].cambio,
                        Vencimento: a[c].vencimento,
                        Pagamento: a[c].dataPagamento,
                        Status: status
                        
                    }
                    b.push(d)
                }


            return [
                {
                    "name":"Pagina 1", 
                    "data": b
                }
            ]

        }
    },
    methods: {

    }
  };
  </script>